import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { PrivaLocalizationModule } from '@priva/localization';

import {
    isRowSelectionFinished,
    isRowSelectionInProgress,
} from 'app/state/row-selection/row-selection.selectors';

import { Activity } from '../activity-selector/models';
import { MapFilterComponent, TerminalOverlayComponent } from './../../components';
import { MapRowListComponent, MapRowSelectorToolbarComponent } from './components';

@Component({
    selector: 'app-map-row-selector',
    templateUrl: './map-row-selector.component.html',
    styleUrl: './map-row-selector.component.scss',
    imports: [
        AsyncPipe,
        PrivaLocalizationModule,
        MapFilterComponent,
        MapRowSelectorToolbarComponent,
        MapRowListComponent,
        TerminalOverlayComponent,
    ],
})
export class MapRowSelectorComponent {
    private destroyRef = inject(DestroyRef);
    private store = inject(Store);

    title = input('');
    selectedActivity = input<Activity | undefined>(undefined);

    closeRequested = output<void>();
    rowsSelected = output<void>();

    isRowSelectionInProgress$: Observable<boolean> = this.store.select(isRowSelectionInProgress);
    isRowSelectionFinished$: Observable<boolean> = this.store.select(isRowSelectionFinished);
    constructor() {
        this.isRowSelectionFinished$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                distinctUntilChanged(),
                filter((finished) => finished),
            )
            .subscribe(() => {
                this.rowsSelected.emit();
            });
    }
    onCloseRequested(): void {
        this.closeRequested.emit();
    }
}
